import axios from 'axios'
import {
    getMessageId,
    isInCloudApp
} from '../utils/index'



const nativeRequest = function (payload = {}) {
    let {
        url,
        data
    } = payload
    return new Promise((resolve, reject) => {
        let p = {
            url,
            params: data,
            timeout: 10000
        }
        jsbridge.excMethod('communityModule', 'forwardCommunityRequest', p, data => {
            if (typeof data == 'string') {
                data = JSON.parse(data);
            }
            if (data.errorCode && data.errorCode != 0) {
                data.code = data.errorCode;
                data.message = data.message || data.msg || '';
                reject(data);
            }
            resolve(data || {});
        });
    })

}

// 兼容 账单和预存入参标准
const residentBillRequestAdapter = (config) => {
    const funcs = [{
        key: 'dataNoContainUserId',
        func: (config) => {
            const {
                userId,
                ...rest
            } = config.data
            config.headers['userId'] = userId
            config.data = rest
            delete config.data.dataNoContainUserId
        }
    }, {
        key: 'hasSigeUserId',
        func: (config) => {
            //  判断入参是否为四格userId
            config.headers['userId'] = config.data.ruizhuUserId
            delete config.data.hasSigeUserId
            delete config.data.ruizhuUserId
        }
    }, {
        key: 'noHeadUserId',
        func: (config) => {
            delete config.data.noHeadUserId
            delete config.headers.userId
        }
    }]
    let hasThatKey = false
    funcs.forEach(item => {
        if (config.data[item.key]) {
            item.func(config)
            hasThatKey = true
        }
        delete config.data[item.key]
    })
    if (!hasThatKey) {
        config.headers['userId'] = config.data.userId;
    }
    return config
}
let show500Error = false
const service = axios.create({
    baseURL: process.env.BASE_URL,
   //baseURL: 'https://remaclife-biz-app-uat.smartmideazy.com',
    timeout: 10000
});
// 请求拦截器
service.interceptors.request.use(config => {
    config.method = 'post'
    if (config.data && (config.data.userId || config.data.userId == 0)) {
        if(/charge\/(common|billPay|preStore)+\//g.test(config.url)) {
            config = residentBillRequestAdapter(config)
            show500Error = config.data.show500Error || false
            delete config.data.show500Error
        } else {
            config.headers['userId'] = config.data.userId;
        }
    }

    //灰度发布标识
    if (process.env.ENV_VERSION) {
        config.headers['version'] = process.env.ENV_VERSION;
    }
    // config.headers['userId'] =  76;
    //config.headers['userId'] = config.data.userId || 0
    return config
})

// 响应拦截器
service.interceptors.response.use(response => {

    const res = response.data
    if (res.code == 200 || res.code == 500) {
        if (res.code == 500 && show500Error) {
            return Promise.reject(res)
        }
        return res.data
    } else if (res.code == 20005) {
        return res.data
    } else {
        return Promise.reject(res)
    }

}, err => {
    if (err.message.includes('timeout')) {
        err.message = '请求超时，请重试'
    }
    if (err.message.includes('Network Error')) {
        err.message = '网络连接不可用，请检查网络设置'
    }
    return Promise.reject(err)
})

let lastScriptElement = null;
export function getRequset({
    url,
    params,
    callback
}) {
    params = params || {}
    // 拼接参数字符串
    const paramKeys = Object.keys(params)
    const paramString = paramKeys
        .map(key => `${key}=${params[key]}`)
        .join('&')
    const script = document.createElement('script')
    if (paramString) {
        script.setAttribute('src', `${url}?${paramString}`)
    } else {
        script.setAttribute('src', url)
    }
    if (lastScriptElement) {
        document.getElementsByTagName('head')[0].removeChild(lastScriptElement)
        lastScriptElement = script;
        document.getElementsByTagName('head')[0].appendChild(lastScriptElement)
    } else {
        lastScriptElement = script;
        document.getElementsByTagName('head')[0].appendChild(lastScriptElement)
    }
    script.onload = script.onreadystatechange = function () {
        if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
            callback();
        }
    };
}


export default isInCloudApp() ? nativeRequest : service


const service2 = axios.create({
   baseURL: process.env.BASE_URL_REAMCLIFE,
    timeout: 10000
});
// 请求拦截器
service2.interceptors.request.use(config => {
    config.method = 'post'
    if (config.data && (config.data.userId || config.data.userId == 0)) {
        if(/charge\/(common|billPay|preStore)+\//g.test(config.url)) {
            config = residentBillRequestAdapter(config)
            show500Error = config.data.show500Error || false
            delete config.data.show500Error
        } else {
            config.headers['userId'] = config.data.userId;
        }
    }

    //灰度发布标识
    if (process.env.ENV_VERSION) {
        config.headers['version'] = process.env.ENV_VERSION;
    }
    // config.headers['userId'] =  76;
    //config.headers['userId'] = config.data.userId || 0
    return config
})

// 响应拦截器
service2.interceptors.response.use(response => {

    const res = response.data
    if (res.code == 200 || res.code == 500) {
        if (res.code == 500) {
            return Promise.reject(res)
        }
        return res.data
    } else if (res.code == 20005) {
        return res.data
    } else {
        return Promise.reject(res)
    }

}, err => {
    if (err.message.includes('timeout')) {
        err.message = '请求超时，请重试'
    }
    if (err.message.includes('Network Error')) {
        err.message = '网络连接不可用，请检查网络设置'
    }
    return Promise.reject(err)
})

export const requestV4 =  isInCloudApp() ? nativeRequest : service2




// WEBPACK FOOTER //
// ./src/api/request.js